module.exports = __webpack_public_path__ + "nicon_excel_export.svg";